import { render } from "./StudioData.vue?vue&type=template&id=624ba584&scoped=true"
import script from "./StudioData.vue?vue&type=script&lang=js"
export * from "./StudioData.vue?vue&type=script&lang=js"

import "./StudioData.vue?vue&type=style&index=0&id=624ba584&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624ba584"]])

export default __exports__